<template>
  <div class="menu-tree-wrap">
    <el-tree
      class="tree"
      ref="menuTree"
      :data="menus"
      :props="defaultProps"
      node-key="id"
      :default-expand-all="true"
      @node-click="handleNodeClick"
      :default-expanded-keys="matchMenus"
      :check-strictly="true"
      accordion
    >
      <div
        class="custom-tree-node"
        :class="data.slotClass"
        slot-scope="{ node, data }"
        v-if="!data.show"
      >
        <template v-if="data.component">
          <component :is="data.component.template" :style="data.component.class" :lineHeight="40"></component>
        </template>
        <span v-if="data.nodeIcon" :class="data.nodeIcon"></span>
        <span class="node-name" :title="node.label">{{ node.label }}</span>
        <div class="slot-wrap">
          <template v-if="data.slots">
            <slot-temp
              v-for="(item, index) in data.slots"
              @clickSlot="item.clickFunc"
              :key="'slot-' + index"
              style="margin-left: 5px"
            >
              <i :class="item.iconClass" :title="item.hoverTitle"></i>
            </slot-temp>
          </template>
        </div>
        <template v-if="data.badge !== ''">
          <span
            class="badge"
            v-show="currentPath === data.id || (currentPath === '/corp/signInfo/sealApproval?signStatus=6' && data.id === '/corp/signInfo/signList?signStatus=5')"
          >{{ data.badge }}</span>
        </template>
      </div>
    </el-tree>
  </div>
</template>

<script>
import SlotTemp from "@/components/apply-menu-tree/slotTemp";
import { isInDingTalk } from '@/assets/js/utils/ding-env';
import { setCurrentUser } from "../../assets/js/http-serve/corp/common";

export default {
  name: "index",
  components: { SlotTemp },
  props: {
    enAccount: {
      type: Boolean,
      default: false,
    },
    menus: {
      type: Array,
      default: function () {
        return [];
      }
    },
    currentMenuName: {
      type: String,
      default: ""
    },
    initCallback: {
      type: Function
    },
    defaultExpandedKeys: {
      type: Array,
      default: function () {
        return [];
      }
    }
  },
  data () {
    return {
      defaultProps: {
        children: "children",
        label: "label"
      },
      currentMenuId: -1, // 当前要选中的菜单id
      matchMenus: [] // 当前要展开的菜单id数组
    };
  },
  computed: {
    currentPath () {
      if (!this.enAccount) {
        return this.$route.fullPath;
      }
      switch (this.$route.query.type) {
        case '2':
          return '/console/accountInfo';
        case '3':
          return '/console/signers';
        case '4':
          return '/console/digital';
        case '5':
          return '/console/signMerge';
        case '6':
          return '/console/preference';
        case '7':
          return '/console/myAuth';
        default:
          return '/console/account';
      };
    }
  },
  mounted () {
    this.resetTree();
    if (this.initCallback) {
      this.initCallback();
    }
  },
  methods: {
    // 点击菜单，跳转路由，并设置当前菜单选11111111111
    handleNodeClick (data) {
      if (['/corp/signInfo/applyList?match=-1', '/signInfo/applyList?match=-1'].includes(data.id)) {
        return false;
      } else if (['/tpl/accountInfo', '/tpl/costStatistics', '/tpl/signers', '/tpl/Preferences', '/tpl/myAuth'].includes(data.id)) { //这个是切换账户、积分等菜单时，必须先切回到自己
        let user = this.$store.getters.allAuthUser.accountInfoVO;
        setCurrentUser(user).finally(() => {
          this.dataBackFn(data);
        });
      } else {
        this.dataBackFn(data);
      }
    },
    //上面函数data返回后续操作
    dataBackFn (data) {
      if (data.route) {
        if (data.route.id === this.$route.fullPath) return
        try {
          this.$router.push(data.route, () => { }, () => { })
        } catch (err) {
          console.log('文件管理跳转_err', err);
        }
      } else if (data.href) {
        isInDingTalk ? location.href = data.href.path : window.open(data.href.path, data.href.target);
      } else if (data.fn) {
        data.fn.call();
      }
    },
    // 根据url，递归获取选中状态的菜单
    findAllLeafs (tree, parent) {
      for (let i = 0, length = tree.length; i < length; i++) {
        // 查找完全相等的url
        if (tree[i].id === this.currentPath) {
          // 记录当前URL匹配的菜单id
          this.currentMenuId = tree[i].id;

          // 同步当前URL匹配的菜单名称给父组件
          this.$emit(
            "update:currentMenuName",
            tree[i].routeName || tree[i].label
          );

          if (parent) {
            // 如果当前选中菜单有父级菜单，则把父级记录到展开菜单数组matchMenus中（因为需要展开父级）
            this.matchMenus.push(parent.id);
          } else {
            // 如果没有父级菜单（一级菜单），则直接把选中菜单记录到展开菜单数组mathMenus中
            this.matchMenus.push(tree[i].id);
          }

          // 如果匹配到了，且有子级菜单，则全部展开
          if (tree[i].children && tree[i].children.length > 0) {
            tree[i].children.forEach(subTree => {
              this.matchMenus.push(subTree.id);
            });
          }

          // 匹配完成，跳出当前循环
          break;
        }

        // 查找包含，如果url带参数，也可以匹配（注意：父级id需要特殊化。tree1、tree2...，如果有重复的id，则要加参数match=-1...）
        // if (this.currentPath.indexOf(tree[i].id) !== -1) {
        if (this.currentPath.split('?').includes(tree[i].id)) {
          // 记录当前URL匹配的菜单id
          this.currentMenuId = tree[i].id;

          // 同步当前URL匹配的菜单名称给父组件
          this.$emit("update:currentMenuName", tree[i].label);

          if (parent) {
            // 如果当前选中菜单有父级菜单，则把父级记录到展开菜单数组matchMenus中（因为需要展开父级）
            this.matchMenus = [parent.id];
          } else {
            // 如果没有父级菜单（一级菜单），则直接把选中菜单记录到展开菜单数组mathMenus中
            this.matchMenus = [tree[i].id];
          }

          // 匹配完成，跳出当前循环
          break;
        }

        // 递归查找匹配，直到叶子节点
        if (tree[i].children) {
          this.findAllLeafs(tree[i].children, tree[i]);
        }
      }
    },
    /**
     * 根据url，重置菜单树的展开、选中状态
     */
    resetTree () {
      this.matchMenus = [].concat(this.defaultExpandedKeys);
      this.findAllLeafs(this.menus); // 递归判断展开菜单
      this.$refs.menuTree.setCheckedKeys([this.currentMenuId]); // 根据路径，选中菜单
      this.$nextTick(this.setSeparateStyle); // 加分割线
    },
    /**
     * 查找最近父元素
     * @param el
     * @param selector
     * @returns {*}
     */
    closest (el, selector) {
      let matchesSelector =
        el.matches ||
        el.webkitMatchesSelector ||
        el.mozMatchesSelector ||
        el.msMatchesSelector;

      while (el) {
        if (matchesSelector.call(el, selector)) {
          break;
        }
        el = el.parentElement;
      }
      return el;
    },
    /**
     * 添加separated属性名，不能用类名（el-tree默认选中事件会改变类名）
     */
    setSeparateStyle () {
      let separateArr = [];
      try {
        separateArr = this.$refs.menuTree.$el.querySelectorAll(".separated");
      } catch (e) {
        console.log(e);
      }
      for (let i = 0, length = separateArr.length; i < length; i++) {
        let eachNode = this.closest.call(
          separateArr[i],
          separateArr[i],
          ".el-tree-node"
        );
        if (eachNode) {
          eachNode.setAttribute("separated", true);
        }
      }
    }
  },
  watch: {
    $route: {
      handler () {
        this.resetTree();
      },
      deep: true
    }
  }
};
</script>

<style lang="less" scoped>
@import url("../../assets/style/cssVariable.less");

.menu-tree-wrap {
  overflow-y: auto;
  overflow-x: hidden;
}

/deep/ .tree {
  padding: 15px 0;
  & > .el-tree-node {
    /*一级菜单 含子菜单*/
    position: relative;
    color: #323232;
    &[separated="true"] {
      padding-bottom: 10px;
      margin-bottom: 10px;
      border-bottom: solid 1px #ebebeb;
    }
    &.is-checked {
      & > .el-tree-node__content {
        color: #ec1c1c;
        background-color: @ebq-left-selected;
      }
    }
    .is-checked {
      & > .el-tree-node__content {
        color: #ec1c1c;
        background-color: @ebq-left-selected;
      }
    }
    & > .el-tree-node__content {
      padding-left: 26px !important;
      font-size: 15px;
    }

    .el-tree-node.is-checked {
      color: #666666;
      .is-checked {
        color: #666666;
        .el-tree-node__content {
          background-color: #f5f7fa;
        }
      }
    }
    .el-tree-node.is-checked {
      .is-checked {
        color: #666666;
      }
    }
    /*竖线*/
    /*&.is-checked, .is-checked {
        &:before {
          display: inline-block;
          position: absolute;
          width: 2px;
          height: 20px;
          content: '';
          background-color: #EC1C1C;
          top: 8px;
          left: 36px;
          z-index: 10;
        }
      }*/
    & > .el-tree-node__content {
      span {
        font-size: 14px;
        vertical-align: middle;
      }
    }
    & > .el-tree-node__children {
      font-weight: 500;
      span {
        font-size: 14px;
        vertical-align: middle;
      }
    }
  }
  .el-tree-node__content {
    position: relative;
    height: unset;
    line-height: 1;
    padding: 0 10px 0 30px !important;
    &[style="padding-left: 18px;"] {
      padding-left: 50px !important;
    }
    .el-icon-caret-right:before {
      /*content: '';
        display: inline-block;
        border-style: solid;
        border-width: 1px;
        width: 6px;
        height: 6px;
        border-color: #666666 #666666 transparent transparent;
        transform: rotate(45deg);*/
      /*content: "\E60E";
        color: #5d5d5d;
        font-size: 20px;*/
      content: "";
      display: inline-block;
      width: 18px;
      height: 18px;
      background-image: url("/images/icon/tree-icon.png");
      background-repeat: no-repeat;
      background-size: 500% 500%;
      background-position: -72px -36px;
    }
  }
  .el-tree-node__expand-icon {
    display: none;
  }
  & > .el-tree-node {
    & > .el-tree-node__content {
      .el-tree-node__expand-icon {
        display: block;
        position: absolute;
        padding: 0;
        left: 5px;
        top: 50%;
        transform: translateY(-50%);
        &.is-leaf {
          opacity: 0;
        }
        &.expanded {
          transform: translateY(-50%) rotate(90deg);
        }
      }
    }
  }
  .el-tree-node__content[style="padding-left: 18px;"] {
    .nodeIcon {
      left: 10px;
    }
  }
  .custom-tree-node {
    display: block;
    width: 100%;
    line-height: 40px;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 0;
    &.showWhenHover {
      .node-name {
        display: inline-block;
        /*width: 60%;*/
        vertical-align: middle;
        white-space: nowrap;
        overflow-x: hidden;
        text-overflow: ellipsis;
      }
    }
    .slot-wrap {
      position: absolute;
      top: 50%;
      height: 30px;
      line-height: 30px;
      margin-top: -15px;
      right: 5px;
      white-space: nowrap;
    }
    .badge {
      /*position: absolute;*/
      /*right: 5px;*/
      /*top: 50%;*/
      font-size: 14px;
      line-height: 1;
      margin-left: 5px;
      /*margin-top: -7px;*/
    }
    &.showWhenHover {
      .slot-wrap {
        display: none;
      }
    }
    &.showWhenHover:hover {
      .slot-wrap {
        display: block;
      }
      .badge {
        display: none;
      }
    }
  }
  .is-leaf {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// components/apply-menu-tree/index.vue